import React, { Component, Fragment } from 'react';
import { NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import authService from './AuthorizeService';
import { ApplicationPaths } from './ApiAuthorizationConstants';
import LogoutIcon from '@mui/icons-material/Logout';

export class LoginMenu extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isAuthenticated: false,
            userName: null,
            proveedor: null
        };
    }

    componentDidMount() {
        this._subscription = authService.subscribe(() => this.populateState());
        this.populateState();
    }

    componentWillUnmount() {
        authService.unsubscribe(this._subscription);
    }

    async populateState() {
        const [isAuthenticated, user, usuario] = await Promise.all([authService.isAuthenticated(), authService.getUser(), this.getUsuario()])
        if (!isAuthenticated) {
            //window.location.href = "/Identity/Account/Login?returnUrl=/";
        }
        this.setState({
            isAuthenticated,
            userName: user && user.name,
            proveedor: usuario.proveedor
        });
    }
    async getUsuario() {
        const token = await authService.getAccessToken();

        const response = await fetch('api/Usuarios', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
        });
        return await response.json();
    }

    render() {
        const { isAuthenticated, userName, proveedor } = this.state;
        if (!isAuthenticated) {

            const registerPath = `${ApplicationPaths.Register}`;
            const loginPath = `${ApplicationPaths.Login}`;
            return this.anonymousView(registerPath, loginPath);
        } else {
            const profilePath = `${ApplicationPaths.Profile}`;
            const logoutPath = `${ApplicationPaths.LogOut}`;
            const logoutState = { local: true };
            return this.authenticatedView(userName, profilePath, logoutPath, logoutState, proveedor);
        }
    }

    authenticatedView(userName, profilePath, logoutPath, logoutState, proveedor) {
        return (
            <Fragment>
                {proveedor ?
                    <NavItem>
                        <NavLink className="text-dark" to={profilePath}><b>Proveedor: </b>{proveedor}</NavLink>
                    </NavItem> : ""}
                {userName ?
                    <NavItem>
                        <NavLink className="text-dark" to={profilePath}><b>Usuario: </b>{userName}</NavLink>
                    </NavItem> : ""}

                {/*  <NavItem>*/}
                {/*      <button onClick={loading() }>Save</button>*/}
                {/*</NavItem>*/}
                <NavItem>
                    <NavLink replace tag={Link} className="text-dark" to={logoutPath} state={logoutState}><LogoutIcon />  Logout</NavLink>
                </NavItem>
            </Fragment>
        );
    }

    anonymousView(registerPath, loginPath) {
        return (<Fragment>
            {/*<NavItem>*/}
            {/*  <NavLink tag={Link} className="text-dark" to={registerPath}>Register</NavLink>*/}
            {/*</NavItem>*/}
            {/*<NavItem>*/}
            {/*  <NavLink tag={Link} className="text-dark" to={loginPath}>Login</NavLink>*/}
            {/*</NavItem>*/}
        </Fragment>);
    }
}
